module.exports = __webpack_public_path__ + "img/new-section-black-logo.9d6a33c9.png";